import { ISearchType } from '@search/offer-search-routes/src';
import { filterCodec2 } from '@search/vtbeco-frontend-core/view/filters/services/codecs/FilterCodec2';
import { classifiedFilterFactory } from '../../filters/ClassifiedFilterFactory';

export function offerSearchPageGetInitialFilters(searchParams: ISearchType) {
    return classifiedFilterFactory.createOrUpdateFilters(filterCodec2.deserialize(searchParams));
}
